import { HttpInterceptorFn } from '@angular/common/http';
import { CHANNEL_CODE_HEADER } from '../../constants/http-headers';
import { environment } from '../../../../environments/environment';

/** Storefront-only: identifies this app as hub-of-naturals on every API call. Admin app must not use this. */
export const channelInterceptor: HttpInterceptorFn = (req, next) =>
  next(
    req.clone({
      setHeaders: {
        [CHANNEL_CODE_HEADER]: environment.channelCode,
      },
    }),
  );
